import React, { useContext } from 'react';

const SyncContext = React.createContext(null);

export const SyncProvider = SyncContext.Provider;
export const SyncConsumer = SyncContext.Consumer;

export const useSyncClient = () => useContext(SyncContext);
